module.exports = __webpack_public_path__ + "img/Lower_Elementary_School.8d6530d5.svg";